import { Box, Typography, CardContent, Card, Grid } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

const BannerDetails = () => {
  const location = useLocation();
  const { banner } = location.state || {};

  if (!banner)
    return (
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box sx={{ padding: 4 }}>
            <Typography>No Banner selected</Typography>
          </Box>
        </CardContent>
      </Card>
    );

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <Typography variant="h5" gutterBottom>
              Banner Details
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          {/* <Typography variant="h6" sx={{ fontWeight: "bold", paddingLeft: 4 }}>
            Personal Details
          </Typography> */}
          <Box sx={{ padding: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Title
                </Typography>
                <Typography variant="body1">{banner.title}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Type
                </Typography>
                <Typography variant="body1">{banner.type}</Typography>
              </Grid>
              {banner.content !== '' ? (
                <Grid item xs={6}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Content
                  </Typography>
                  <Typography variant="body1">{banner.content}</Typography>
                </Grid>
              ) : (
                ''
              )}

              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Image
                </Typography>
                <Typography variant="body1">
                  <img
                    src={
                      banner.image
                        ? typeof banner.image === 'string'
                          ? banner.image // Use directly if it's a URL string
                          : banner.image instanceof File ||
                            banner.image instanceof Blob
                            ? URL.createObjectURL(banner.image) // Create a URL for File/Blob
                            : ''
                        : ''
                    }
                    alt="Banner Preview"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      marginBottom: '16px',
                      borderRadius: '4px',
                    }}
                  />
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default BannerDetails;
